import { useEffect, useRef } from "react";
import { App } from "@capacitor/app";
import { PluginListenerHandle } from "@capacitor/core";

export function useBackButton(callback: (() => void) | null) {
  const handleRef = useRef<PluginListenerHandle | null>(null);

  useEffect(() => {
    // Clean up any existing listener before adding a new one
    if (handleRef.current) {
      handleRef.current.remove();
      handleRef.current = null;
    }

    if (callback) {
      // Add listener and store handle
      const promise = App.addListener("backButton", callback);
      promise.then((h) => {
        handleRef.current = h;
      });
    }

    return () => {
      // Clean up on unmount or callback change
      if (handleRef.current) {
        handleRef.current.remove();
        handleRef.current = null;
      }
    };
  }, [callback]);
}
